export const FE_ASSIGNED_ORDERS_REQUEST = "FE_ASSIGNED_ORDERS_REQUEST";
export const FE_ASSIGNED_ORDERS_FAILURE = "FE_ASSIGNED_ORDERS_FAILURE";
export const FE_ASSIGNED_ORDERS_SUCCESS = "FE_ASSIGNED_ORDERS_SUCCESS";
